export default __webpack_public_path__ + "static/media/151-invention.43b660bc.png";